import produce from 'immer';
import {
  GET_HELP_CATEGORIES_START,
  GET_HELP_CATEGORIES_SUCCESS,
  GET_HELP_CATEGORIES_FAILED,
  GET_HELP_SUB_CATEGORIES_START,
  GET_HELP_SUB_CATEGORIES_SUCCESS,
  GET_HELP_SUB_CATEGORIES_FAILED,
  GET_HELP_TOPICS_START,
  GET_HELP_TOPICS_SUCCESS,
  GET_HELP_TOPICS_FAILED,
  GET_ALL_HELP_TOPICS_START,
  GET_ALL_HELP_TOPICS_SUCCESS,
  GET_ALL_HELP_TOPICS_FAILED,
  ADD_HELP_CATEGORY_START,
  ADD_HELP_CATEGORY_SUCCESS,
  ADD_HELP_CATEGORY_FAILED,
  ADD_HELP_SUB_CATEGORY_START,
  ADD_HELP_SUB_CATEGORY_SUCCESS,
  ADD_HELP_SUB_CATEGORY_FAILED,
  ADD_HELP_TOPIC_START,
  ADD_HELP_TOPIC_SUCCESS,
  ADD_HELP_TOPIC_FAILED,
  DELETE_HELP_CATEGORY_SUCCESS,
  DELETE_HELP_CATEGORY_START,
  DELETE_HELP_CATEGORY_FAILED,
  DELETE_HELP_SUB_CATEGORY_START,
  DELETE_HELP_SUB_CATEGORY_SUCCESS,
  DELETE_HELP_SUB_CATEGORY_FAILED,
  EDIT_HELP_CATEGORY_START,
  EDIT_HELP_CATEGORY_SUCCESS,
  EDIT_HELP_CATEGORY_FAILED,
  EDIT_HELP_SUB_CATEGORY_START,
  EDIT_HELP_SUB_CATEGORY_SUCCESS,
  EDIT_HELP_SUB_CATEGORY_FAILED,
  EDIT_HELP_TOPIC_START,
  EDIT_HELP_TOPIC_SUCCESS,
  EDIT_HELP_TOPIC_FAILED,
  DELETE_HELP_TOPIC_START,
  DELETE_HELP_TOPIC_SUCCESS,
  DELETE_HELP_TOPIC_FAILED
} from '../actions/help';


const initialState = {
  isLoadingAllHelpTopics: false,
  isLoadingHelpCategories: false,
  isLoadingHelpTopics: false,
  isLoadingHelpSubCategories: false,
  helpCategories: [],
  helpSubCategories: [],
  helpTopics: [],
  allHelpTopics: []
};

const formReducer = produce((state: IHelpState = initialState, action) => {
  switch (action.type) {
    case GET_HELP_CATEGORIES_START: {
      state.isLoadingHelpCategories = true;
      break;
    }
    case GET_HELP_CATEGORIES_SUCCESS: {
      const { data } = action;

      state.helpCategories = data.categories;
      state.isLoadingHelpCategories = false;
      break;
    }
    case GET_HELP_CATEGORIES_FAILED: {
      state.isLoadingHelpCategories = false;
      break;
    }
    case GET_HELP_SUB_CATEGORIES_START: {
      state.isLoadingHelpSubCategories = true;
      break;
    }
    case GET_HELP_SUB_CATEGORIES_SUCCESS: {
      const { data } = action;

      state.helpSubCategories = data.subCategories;
      state.isLoadingHelpSubCategories = false;
      break;
    }
    case GET_HELP_SUB_CATEGORIES_FAILED: {
      state.isLoadingHelpSubCategories = false;
      break;
    }
    case GET_HELP_TOPICS_START: {
      state.isLoadingHelpTopics = true;
      break;
    }
    case GET_HELP_TOPICS_SUCCESS: {
      const { data } = action;

      state.helpTopics = data.topics;
      state.isLoadingHelpTopics = false;
      break;
    }
    case GET_HELP_TOPICS_FAILED: {
      state.isLoadingHelpTopics = false;
      break;
    }
    case GET_ALL_HELP_TOPICS_START: {
      state.isLoadingAllHelpTopics = true;
      break;
    }
    case GET_ALL_HELP_TOPICS_SUCCESS: {
      const { data } = action;

      state.allHelpTopics = data.topics;
      state.isLoadingAllHelpTopics = false;
      break;
    }
    case GET_ALL_HELP_TOPICS_FAILED: {
      state.isLoadingAllHelpTopics = false;
      break;
    }
    case ADD_HELP_CATEGORY_START: {
      state.isLoadingHelpCategories = true;
      break;
    }
    case ADD_HELP_CATEGORY_SUCCESS: {
      const { data } = action;

      state.helpCategories = [...state.helpCategories, data.category];
      state.isLoadingHelpCategories = false;
      break;
    }
    case ADD_HELP_CATEGORY_FAILED: {
      state.isLoadingHelpCategories = false;
      break;
    }
    case ADD_HELP_SUB_CATEGORY_START: {
      state.isLoadingHelpSubCategories = true;
      break;
    }
    case ADD_HELP_SUB_CATEGORY_SUCCESS: {
      const {data} = action;

      state.helpSubCategories = [...state.helpSubCategories, data.subCategory];
      state.isLoadingHelpSubCategories = false;
      break;
    }
    case ADD_HELP_SUB_CATEGORY_FAILED: {
      state.isLoadingHelpSubCategories = false;
      break;
    }
    case ADD_HELP_TOPIC_START: {
      state.isLoadingHelpTopics = true;
      break;
    }
    case ADD_HELP_TOPIC_SUCCESS: {
      const {data} = action;

      state.allHelpTopics = [...state.allHelpTopics, data.topic];
      state.isLoadingHelpTopics = false;
      break;
    }
    case ADD_HELP_TOPIC_FAILED: {
      state.isLoadingHelpTopics = false;
      break;
    }
    case EDIT_HELP_CATEGORY_START: {
      state.isLoadingHelpCategories = true;
      break;
    }
    case EDIT_HELP_CATEGORY_SUCCESS: {
      const {category} = action.data;

      state.helpCategories = state.helpCategories.map((el) => el._id === category._id ? {...el, ...category} : el);
      state.isLoadingHelpCategories = false;
      break;
    }
    case EDIT_HELP_CATEGORY_FAILED: {
      state.isLoadingHelpCategories = false;
      break;
    }
    case EDIT_HELP_SUB_CATEGORY_START: {
      state.isLoadingHelpSubCategories = true;
      break;
    }
    case EDIT_HELP_SUB_CATEGORY_SUCCESS: {
      const {subCategory} = action.data;

      state.helpSubCategories = state.helpSubCategories.map((el) => el._id === subCategory._id ? {...el, ...subCategory} : el);
      state.isLoadingHelpSubCategories = false;
      break;
    }
    case EDIT_HELP_SUB_CATEGORY_FAILED: {
      state.isLoadingHelpSubCategories = false;
      break;
    }
    case EDIT_HELP_TOPIC_START: {
      state.isLoadingHelpTopics = true;
      break;
    }
    case EDIT_HELP_TOPIC_SUCCESS: {
      const {topic} = action.data;

      state.allHelpTopics = state.allHelpTopics.map((el) => el._id === topic._id ? {...el, ...topic} : el);
      state.isLoadingHelpTopics = false;
      break;
    }
    case EDIT_HELP_TOPIC_FAILED: {
      state.isLoadingHelpTopics = false;
      break;
    }
    case DELETE_HELP_CATEGORY_START: {
      state.isLoadingHelpCategories = true;
      break;
    }
    case DELETE_HELP_CATEGORY_SUCCESS: {
      const {data} = action;

      state.helpCategories = state.helpCategories.filter((el) => el._id !== data);
      state.isLoadingHelpCategories = false;
      break;
    }
    case DELETE_HELP_CATEGORY_FAILED: {
      state.isLoadingHelpCategories = false;
      break;
    }
    case DELETE_HELP_SUB_CATEGORY_START: {
      state.isLoadingHelpSubCategories = true;
      break;
    }
    case DELETE_HELP_SUB_CATEGORY_SUCCESS: {
      const {data} = action;

      state.helpSubCategories = state.helpSubCategories.filter((el) => el._id !== data);
      state.isLoadingHelpSubCategories = false;
      break;
    }
    case DELETE_HELP_SUB_CATEGORY_FAILED: {
      state.isLoadingHelpSubCategories = false;
      break;
    }
    case DELETE_HELP_TOPIC_START: {
      state.isLoadingHelpTopics = true;
      break;
    }
    case DELETE_HELP_TOPIC_SUCCESS: {
      const {data} = action;

      state.allHelpTopics = state.allHelpTopics.filter((el) => el._id !== data);
      state.isLoadingHelpTopics = false;
      break;
    }
    case DELETE_HELP_TOPIC_FAILED: {
      state.isLoadingHelpTopics = false;
      break;
    }
    default:
      break;
  }
}, initialState);

export default formReducer;
